import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {combineLatest, Subject} from 'rxjs';
import {SelectedStoreState} from '../+state/stores.reducer';
import {getCurrentStoreViewStatus, getCustomerProfile, getSelectedStore} from '../+state/stores.selectors';
import {CustomerAuthService} from '../../customer-auth.service';
import {LocationService} from '../../location.service';
import {CustomerProfile} from '../types/CustomerSocialLogin';
import {filter, takeUntil} from 'rxjs/operators';
import {CollapsePanelComponent} from '../../../shared/collapse-panel/collapse-panel.component';

@Component({
  selector: 'app-store-customer-profile',
  templateUrl: './store-customer-profile.component.html',
  styleUrl: './store-customer-profile.component.scss',
})
export class StoreCustomerProfileComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject<void>();
  openPanels: string[] = ['profile'];

  @ViewChild('profile') profilePanel: CollapsePanelComponent;
  @ViewChild('orders') ordersPanel: CollapsePanelComponent;
  @ViewChild('loyalty') loyaltyPanel: CollapsePanelComponent;

  customerProfile: CustomerProfile;
  loyaltyEnabled = false;

  constructor(
    private store: Store<SelectedStoreState>,
    private customerAuthService: CustomerAuthService,
    private locationService: LocationService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const target = this.locationService.getParamAt(1);

    if (target) {
      this.openPanels = [target];
    }

    combineLatest([
      this.store.select(getSelectedStore),
      this.store.select(getCurrentStoreViewStatus),
    ])
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(([store, status]) => !!store?.id && status.state === 'PROFILE'),
      )
      .subscribe(([selectedStore]) => {
        if (!this.customerAuthService.isUserLoggedIn()) {
          this.router.navigateByUrl(this.locationService.base_url('login'));
        } else {
          this.loyaltyEnabled = !!selectedStore.settings.LOYALTY_SCHEME;
        }
      });

    this.store
      .select(getCustomerProfile)
      .subscribe((customerProfile: CustomerProfile) => {
        this.customerProfile = customerProfile;
      });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        const target = this.locationService.getParamAt(1) || 'profile';
        const panels = {
          profile: this.profilePanel,
          orders: this.ordersPanel,
          loyalty: this.loyaltyPanel
        };
        if (panels[target]) {
          Object.values(panels).forEach(panel => panel?.closePanel());
          panels[target]?.openPanel();
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
